import axiosInstance from '../api/axios';

const getReportResults = async (username,token,nodeId) => {

    const response = await axiosInstance.post("/report/getreportresults",
        {},
        {
            params: {
                username,
                token,
                nodeId
            }
        });

    try {        
            const result = await response.data;        
            var resultJSON = JSON.parse(result);                    
            return resultJSON;
        
    } catch (err) {
        console.error("ERRO [Report, getReportResults]: Falha ao obter resultados da operação.", err);
        if (!err?.response) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
        }
    }
}

export default getReportResults;